export default "__VITE_ASSET__Dfp_ifAW__"